import { Web3DViewer } from '@technology/web3d';
import { CapabilityProviderBase } from './provider-base';

/**
 * Provides data for single pane, so has single viewer.
 */
export abstract class SingleCapabilityProviderBase<
  TModel,
  TKey extends keyof TModel = keyof TModel,
> extends CapabilityProviderBase<TModel, TKey> {
  constructor(public viewer: Web3DViewer) {
    super();
  }
}
